<template>
    <div class="container admin-table-page">

        <!-- ==================== TÍTULO ==================== -->
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100">
                <div class="d-flex align-items-center">
                    <b-button
                        class="page-back-btn mr-2"
                        variant="link"
                        @click="goBack"
                    >
                        <font-awesome-icon
                            :icon="['fas', 'arrow-alt-circle-left']"
                            class="back-icon"
                        />
                    </b-button>

                    <h2 class="param-title">
                        {{ tituloConsolidado || labels.title }}
                    </h2>
                </div>
            </div>
        </div>

        <!-- ==================== FILTROS ==================== -->
        <div class="param-title-wrap niif-header">
            <div
                class="d-flex align-items-center w-100"
                style="flex-wrap: wrap; gap: 8px;"
            >

                <!-- Filtros principales -->
                <div
                    class="filters-container d-flex align-items-center"
                    style="flex-wrap: wrap; gap: 8px;"
                >

                    <!-- Reporte -->
                    <b-form-select
                        v-model="dialogReportes"
                        @change="onFiltroChange"
                        class="filter-select"
                    >
                        <b-form-select-option value="">
                            {{ labels.selectReport }}
                        </b-form-select-option>

                        <option
                            v-for="reporte in reportes"
                            :key="reporte.id"
                            :value="reporte.codigo"
                        >
                            {{ reporte?.nombre }}
                        </option>
                    </b-form-select>

                    <!-- Vigencia -->
                    <b-form-select
                        v-model="dialogFechas"
                        @change="onFiltroChange"
                        class="filter-select"
                    >
                        <b-form-select-option value="">
                            {{ labels.selectValidity }}
                        </b-form-select-option>

                        <option
                            v-for="fecha in fechas"
                            :key="fecha.fecha"
                            :value="fecha.fecha"
                        >
                            {{ fecha?.fecha }}
                        </option>
                    </b-form-select>

                    <!-- Grupo -->
					<b-form-select
						v-model="grupoId"
						@change="(value) => filtraCompaniasPorGrupo(value)"
						class="filter-select"
					>
						<option value="todos">
							{{ labels.allGroups }}
						</option>

						<option
							v-for="grupo in listGrupos"
							:key="'grupo-' + grupo.id"
							:value="grupo.id"
						>
							{{ grupo?.nombre }}
						</option>
					</b-form-select>

                    <!-- Compañía -->
                    <b-form-select
                        v-model="dialogCompanias"
                        @change="seleccionaCompania()"
                        class="filter-select"
                    >
                        <b-form-select-option value="">
                            {{ labels.selectCompany }}
                        </b-form-select-option>

                        <option
                            v-for="compania in companiasFiltradas"
                            :key="compania.id"
                            :value="compania.id"
                        >
                            {{ compania?.acronym ? compania?.acronym + ' ' : '' }}
                            {{ compania?.nombre }}
                        </option>
                    </b-form-select>

                    <!-- Dropdown de selección única para vistas -->
                    <b-dropdown
                        variant="outline-secondary"
                        class="filter-dropdown"
                        toggle-class="filter-dropdown-btn"
                        :text="selectedViewOptionText"
                    >
                        <!-- Grupo Reportes -->
                        <b-dropdown-header>Reportes</b-dropdown-header>
                        <b-dropdown-item
                            v-for="option in viewOptions.filter(o => o.group === 'Reportes')"
                            :key="option.value"
                            @click="selectViewOption(option.value)"
                            :active="selectedViewOption === option.value"
                        >
                            {{ option.text }}
                        </b-dropdown-item>

                        <b-dropdown-divider></b-dropdown-divider>

                        <!-- Grupo Información -->
                        <b-dropdown-header>Información</b-dropdown-header>
                        <b-dropdown-item
                            v-for="option in viewOptions.filter(o => o.group === 'Información')"
                            :key="option.value"
                            @click="selectViewOption(option.value)"
                            :active="selectedViewOption === option.value"
                        >
                            {{ option.text }}
                        </b-dropdown-item>
                    </b-dropdown>

                </div>

                <!-- Botones -->
                <div class="filters-container d-flex align-items-center">

                    <!-- Generar -->
                    <b-button
                        class="consult-btn"
                        @click="generar"
                        :disabled="
                            !dialogFechas ||
                            !dialogReportes ||
                            !dialogCompanias ||
                            !selectedViewOption
                        "
                    >
                        <font-awesome-icon
                            :icon="['fas', 'search']"
                            class="mr-1"
                        />

                        {{ labels.generar }}
                    </b-button>

                </div>

            </div>
        </div>

        <!-- ==================== MODAL SELECCIÓN DE EMPRESAS PARA CONSOLIDADO ==================== -->
        <b-modal
            v-model="showEmpresasModal"
            :title="labels.selectCompanies"
            size="lg"
            @hidden="showEmpresasModal = false"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog create-ajuste-dialog"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title" style="font-size: 16px; font-weight: 600; color: #2e507a;">
                        {{ labels.selectCompaniesTitle }}
                    </div>
                    <div class="password-policy-subtitle" style="font-size: 14px; color: #6c757d;">
                        {{ labels.selectCompaniesSubtitle }}
                    </div>
                </div>

                <!-- ==================== SELECCIÓN DE NIVELES ==================== -->
                <div class="nivel-selection-section mb-4">
                    <div class="d-flex align-items-center flex-wrap" style="gap: 16px;">
                        <span style="font-weight: 600; font-size: 14px; color: #2e507a;">{{ labels.selectLevel }}:</span>
                        
                        <b-form-radio-group
                            v-model="nivelSeleccionado"
                            :options="nivelOptions"
                            buttons
                            button-variant="outline-secondary"
                            size="sm"
                            class="nivel-radio-group"
                            @change="onNivelChange"
                        />
                    </div>
                </div>

                <!-- Lista de empresas -->
                <div class="accounts-section mt-2">
                    <div v-if="companiasFiltradas.length > 0" class="accounts-list mt-1">
                        <div class="select-all-container mb-2 d-flex align-items-center justify-content-between">
                            <b-button
                                size="sm"
                                style="background-color: #2e507a; border-color: #2e507a; font-size: 13px; padding: 4px 16px; border-radius: 4px; color: white;"
                                @click="toggleSelectAllCompaniesModal"
                            >
                                {{ selectAllCompaniesModal ? labels.deselectAll : labels.selectAll }}
                            </b-button>
                            <span style="font-size: 13px; color: #6c757d;">
                                {{ labels.selected }}: <strong>{{ EmpresasConsolida.length }}</strong> / {{ companiasFiltradas.length }}
                            </span>
                        </div>

                        <div class="custom-scroll-table" style="min-height: 200px; height: auto; max-height: 300px; overflow-y: auto;">
                            <table class="table table-sm table-hover" style="font-size: 13px; margin-bottom: 0;">
                                <thead style="position: sticky; top: 0; background: #f8f9fa; z-index: 1;">
                                    <tr>
                                        <th style="width: 100px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                            {{ labels.code }}
                                        </th>
                                        <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                            {{ labels.companyName }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="compania in companiasFiltradas"
                                        :key="compania.id"
                                        @click="toggleCompanySelectionModal(compania)"
                                        :class="{'table-active-blue': isCompanySelectedModal(compania)}"
                                        style="cursor: pointer; border-radius: 8px;"
                                    >
                                        <td style="padding: 5px 8px; border-radius: 8px 0 0 8px;">
                                            <strong>{{ compania?.acronym || compania?.codigo || '' }}</strong>
                                        </td>
                                        <td style="padding: 5px 8px; border-radius: 0 8px 8px 0;" :title="compania.nombre">
                                            {{ compania?.nombre }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div v-else class="text-center py-4" style="height: 200px; display: flex; align-items: center; justify-content: center;">
                        <span class="text-muted" style="font-size: 13px;">{{ labels.noCompaniesAvailable }}</span>
                    </div>
                </div>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button
                        class="mr-2 reset-btn-secondary"
                        @click="closeEmpresasModal"
                        :disabled="isSavingCompanies"
                        style="font-size: 14px; padding: 6px 24px;"
                    >
                        {{ labels.close }}
                    </b-button>
                    <b-button
                        class="reset-btn-primary"
                        @click="confirmEmpresasSelectionModal"
                        :disabled="isSavingCompanies || EmpresasConsolida.length === 0"
                        style="font-size: 14px; padding: 6px 24px;"
                    >
                        {{ labels.confirmSelection }}
                    </b-button>
                </div>
            </div>
        </b-modal>

        <!-- ========================================================= -->
        <!-- ==================== CONTENIDO PRINCIPAL ================= -->
        <!-- ========================================================= -->
        <div class="admin-table-block mt-4">

            <!-- ==================== COMPARATIVO ==================== -->
            <div v-if="comparativo">
                <CorporateDataTable
                    :items="balanceFiltrado"
                    :fields="comparativoFields"
                    :labels="tableLabels"
                    :loading="isLoading"
                    :default-per-page="balanceFiltrado.length || 10"
                    :page-options="[balanceFiltrado.length || 10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="true"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="comparativoFilterDefs"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right">
                            <b-button
                                v-if="fgl_excel"
                                @click="excel(1)"
                                class="table-toolbar-export-btn"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'file-excel']"
                                    class="mr-1"
                                />
                                {{ labels.exportExcel }}
                            </b-button>
                        </div>
                    </template>

                    <template #empty-state>
                        <div class="text-center py-5">
                            <font-awesome-icon
                                :icon="['fas', 'file-alt']"
                                size="4x"
                                class="text-muted mb-3"
                                style="opacity: 0.3;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.empty }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>

            <!-- ==================== DIRECTO / INDIRECTO ==================== -->
            <div v-if="(directo || indirecto) && !informacion && !infAjusteConsol && !infAjusteComb && !consolidado">
                <CorporateDataTable
                    :items="balanceFiltrado"
                    :fields="directoIndirectoFields"
                    :labels="tableLabels"
                    :loading="isLoading"
                    :default-per-page="balanceFiltrado.length || 10"
                    :page-options="[balanceFiltrado.length || 10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="true"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="directoIndirectoFilterDefs"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right">
                            <b-button
                                v-if="fgl_excel"
                                @click="excel(2)"
                                class="table-toolbar-export-btn"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'file-excel']"
                                    class="mr-1"
                                />
                                {{ labels.exportExcel }}
                            </b-button>
                        </div>
                    </template>

                    <template #empty-state>
                        <div class="text-center py-5">
                            <font-awesome-icon
                                :icon="['fas', 'file-alt']"
                                size="4x"
                                class="text-muted mb-3"
                                style="opacity: 0.3;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.empty }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>

            <!-- ==================== CONSOLIDADO ==================== -->
            <div v-if="(directo || indirecto) && !informacion && consolidado">
                <CorporateDataTable
                    :items="balanceFiltrado"
                    :fields="consolidadoFields"
                    :labels="tableLabels"
                    :loading="isLoading"
                    :default-per-page="balanceFiltrado.length || 10"
                    :page-options="[balanceFiltrado.length || 10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="true"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="consolidadoFilterDefs"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right d-flex align-items-center" style="gap: 8px; flex-wrap: wrap;">

                            <!-- Selector de moneda -->
                            <b-form-select
                                v-if="mostrarSelectorMonedaConsolidado"
                                v-model="monedaConsolidadoSeleccion"
                                @change="onCambioMonedaConsolidado"
                                class="form-control form-control-sm"
                                style="min-width: 165px; max-width: 165px;"
                            >
                                <option
                                    v-for="option in monedaConsolidadoOptions"
                                    :key="'reporte-' + option.value"
                                    :value="option.value"
                                >
                                    {{ option?.text }}
                                </option>
                            </b-form-select>

                            <!-- Switch Normal / Combinado -->
                            <div class="compact-toggle-container d-flex align-items-center" style="gap: 8px;">
                                <span style="font-size: 13px; color: #495057; font-weight: 500;">{{ vistaConsolidado === 'Normal' ? labels.normal : labels.combined }}</span>
                                <label class="compact-switch" style="margin: 0;">
                                    <input type="checkbox" v-model="vistaConsolidadoBool">
                                    <span class="compact-slider"></span>
                                </label>
                            </div>

                            <!-- Exportar Excel -->
                            <b-button
                                v-if="fgl_excel"
                                @click="excel(4)"
                                class="table-toolbar-export-btn"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'file-excel']"
                                    class="mr-1"
                                />
                                {{ labels.exportExcel }}
                            </b-button>

                        </div>
                    </template>

                    <template #empty-state>
                        <div class="text-center py-5">
                            <font-awesome-icon
                                :icon="['fas', 'file-alt']"
                                size="4x"
                                class="text-muted mb-3"
                                style="opacity: 0.3;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.empty }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>

            <!-- ==================== INFORMACIÓN (VALOR MANUAL) ==================== -->
            <div v-if="informacion">
                <CorporateDataTable
                    :items="balanceFiltrado"
                    :fields="informacionFields"
                    :labels="tableLabels"
                    :loading="isLoading"
                    :default-per-page="balanceFiltrado.length || 10"
                    :page-options="[balanceFiltrado.length || 10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="true"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="informacionFilterDefs"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right">
                            <b-button
                                v-if="fgl_excel"
                                @click="excel(3)"
                                class="table-toolbar-export-btn"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'file-excel']"
                                    class="mr-1"
                                />
                                {{ labels.exportExcel }}
                            </b-button>
                        </div>
                    </template>

                    <template #cell(accionEdit)="data">
                        <b-button
                            style="background-color: #FF924C; width: 30px; height: 30px;"
                            class="md-fab md-primary table-action-btn"
                            @click="f_muestra([data.item])"
                            :disabled="isVigenciaBloqueada"
                        >
                            <i><font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs"/></i>
                        </b-button>
                    </template>

                    <template #empty-state>
                        <div class="text-center py-5">
                            <font-awesome-icon
                                :icon="['fas', 'file-alt']"
                                size="4x"
                                class="text-muted mb-3"
                                style="opacity: 0.3;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.empty }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>

            <!-- ==================== AJUSTE CONSOL ==================== -->
            <div v-if="infAjusteConsol">
                <CorporateDataTable
                    :items="balanceFiltrado"
                    :fields="informacionFields"
                    :labels="tableLabels"
                    :loading="isLoading"
                    :default-per-page="balanceFiltrado.length || 10"
                    :page-options="[balanceFiltrado.length || 10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="true"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="informacionFilterDefs"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right">
                            <b-button
                                v-if="fgl_excel"
                                @click="excel(5)"
                                class="table-toolbar-export-btn"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'file-excel']"
                                    class="mr-1"
                                />
                                {{ labels.exportExcel }}
                            </b-button>
                        </div>
                    </template>

                    <template #cell(accionEdit)="data">
                        <b-button
                            style="background-color: #FF924C; width: 30px; height: 30px; padding: 0; border-radius: 50%; border: none;"
                            class="md-fab md-primary table-action-btn"
                            @click="f_muestraConsol([data.item])"
                            :disabled="isVigenciaBloqueada"
                        >
                            <i><font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs" style="color: white;"/></i>
                        </b-button>
                    </template>

                    <template #empty-state>
                        <div class="text-center py-5">
                            <font-awesome-icon
                                :icon="['fas', 'file-alt']"
                                size="4x"
                                class="text-muted mb-3"
                                style="opacity: 0.3;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.empty }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>

            <!-- ==================== AJUSTE COMBINADO ==================== -->
            <div v-if="infAjusteComb">
                <CorporateDataTable
                    :items="balanceFiltrado"
                    :fields="informacionFields"
                    :labels="tableLabels"
                    :loading="isLoading"
                    :default-per-page="balanceFiltrado.length || 10"
                    :page-options="[balanceFiltrado.length || 10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="true"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="informacionFilterDefs"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right">
                            <b-button
                                v-if="fgl_excel"
                                @click="excel(6)"
                                class="table-toolbar-export-btn"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'file-excel']"
                                    class="mr-1"
                                />
                                {{ labels.exportExcel }}
                            </b-button>
                        </div>
                    </template>

                    <template #cell(accionEdit)="data">
                        <b-button
                            style="background-color: #FF924C; width: 30px; height: 30px; padding: 0; border-radius: 50%; border: none;"
                            class="md-fab md-primary table-action-btn"
                            @click="f_muestraComb([data.item])"
                            :disabled="isVigenciaBloqueada"
                        >
                            <i><font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs" style="color: white;"/></i>
                        </b-button>
                    </template>

                    <template #empty-state>
                        <div class="text-center py-5">
                            <font-awesome-icon
                                :icon="['fas', 'file-alt']"
                                size="4x"
                                class="text-muted mb-3"
                                style="opacity: 0.3;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.empty }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>

            <!-- ========================================================= -->
            <!-- ==================== SIN SELECCIÓN ====================== -->
            <!-- ========================================================= -->
            <div
                v-if="
                    !comparativo &&
                    !directo &&
                    !indirecto &&
                    !informacion &&
                    !infAjusteConsol &&
                    !infAjusteComb
                "
            >
                <CorporateDataTable
                    :items="[]"
                    :fields="[]"
                    :labels="tableLabels"
                    :loading="false"
                    :default-per-page="10"
                    :page-options="[10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="false"
                    :allow-column-toggle="false"
                    :enable-sorting="false"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #empty-state>
                        <div class="text-center py-5">
                            <img
                                src="../../assets/imgs/file-2.svg"
                                alt="warning"
                                class="mb-3"
                                style="opacity: 0.3; width: 80px;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.selectCriteria }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>

        </div>

        <!-- ==================== MODAL INFORMACIÓN (VALOR MANUAL) ==================== -->
        <b-modal
            v-model="showDialogInformacion"
            :title="f_titulo_informacion()"
            @hidden="showDialogInformacion = false"
            header-class="modal-header-custom"
            footer-class="modal-footer-custom"
            size="md"
        >
            <b-form @submit.prevent="f_grabaInformacion">
                <b-row class="mb-3">
                    <b-col>
                        <label class="font-weight-bold">{{ labels.nivel1 }}</label>
                        <b-form-input
                            v-model="formInformacion.nivel_1_desc"
                            disabled
                            class="bg-light"
                        />
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col>
                        <label class="font-weight-bold">{{ labels.nivel2 }}</label>
                        <b-form-input
                            v-model="formInformacion.nivel_2_desc"
                            disabled
                            class="bg-light"
                        />
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col>
                        <label class="font-weight-bold">{{ labels.nivel3 }}</label>
                        <b-form-input
                            v-model="formInformacion.nivel_3_desc"
                            disabled
                            class="bg-light"
                        />
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col>
                        <label class="font-weight-bold">{{ labels.nivel4 }}</label>
                        <b-form-input
                            v-model="formInformacion.nivel_4_desc"
                            disabled
                            class="bg-light"
                        />
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col>
                        <label class="font-weight-bold">{{ labels.monto }}</label>
                        <b-form-input
                            v-model="formInformacion.valor"
                            type="number"
                            step="0.01"
                            class="form-control"
                            :disabled="isVigenciaBloqueada"
                        />
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col>
                        <label class="font-weight-bold">{{ labels.funcional1 }}</label>
                        <b-form-input
                            v-model="formInformacion.funcional1"
                            type="number"
                            step="0.01"
                            class="form-control"
                            :disabled="isVigenciaBloqueada"
                        />
                    </b-col>
                </b-row>
            </b-form>

            <template #footer>
                <b-button
                    variant="primary"
                    @click="f_grabaInformacion()"
                    :disabled="isVigenciaBloqueada"
                >
                    {{ labels.save }}
                </b-button>
                <b-button
                    variant="secondary"
                    @click="showDialogInformacion = false"
                >
                    {{ labels.close }}
                </b-button>
            </template>
        </b-modal>

    </div>
</template>

<script>
import Balance from "@/services/BalanceNiif"
import Currency from "@/services/Currency"
import BotonesControl from "@/services/BotonesControl"
import Grupo from "@/services/Grupo"
import CorporateDataTable from '../utils/CorporateDataTable.vue'

export default {
    name: "ReporteEFE",
    components: {
        CorporateDataTable
    },
    data: () => ({
        selectedViewOption: null,
        viewOptions: [
            // Grupo "Reportes"
            //{ value: 'comparativo', text: 'Comparativo', group: 'Reportes' },
            //{ value: 'directo', text: 'Directo', group: 'Reportes' },
            { value: 'indirecto', text: 'Indirecto', group: 'Reportes' },
            { value: 'consolidado', text: 'Consolidado', group: 'Reportes' },
            // Grupo "Información"
            { value: 'informacion', text: 'Valor Manual', group: 'Información' },
            { value: 'infAjusteConsol', text: 'Ajuste Consol', group: 'Información' },
            { value: 'infAjusteComb', text: 'Ajuste Combinado', group: 'Información' }
        ],

        // Modal de empresas
        showEmpresasModal: false,
        selectAllCompaniesModal: false,
        isSavingCompanies: false,
        pendingGenerate: false,
        fromButtonGenerate: false,

        // Nivel seleccionado para consolidado
        nivelSeleccionado: 1,
        nivelOptions: [
            { text: 'Nivel 1', value: 1 },
            { text: 'Nivel 2', value: 2 },
            { text: 'Nivel 3', value: 3 },
            { text: 'Nivel 4', value: 4 }
        ],

        // Variables de estado
        showDialog: false,
        showDialogInformacion: false,
        dialogItem: {},
        balance: [],
        searched: [],
        isEmpty: true,
        isLoading: false,
        fgl_excel: true,
        error: false,

        // Formulario de información
        formInformacion: {
            nivel_1: '',
            nivel_1_desc: '',
            nivel_2: '',
            nivel_2_desc: '',
            nivel_3: '',
            nivel_3_desc: '',
            nivel_4: '',
            nivel_4_desc: '',
            valor: '',
            funcional1: '',
            u_modifica: '',
            directo: '',
            esConsolidado: 0
        },

        // Filtros
        idCompania: 0,
        moneda: '',
        vigencia: '',
        codReporte: '',

        // Tipos de vista
        comparativo: false,
        directo: false,
        indirecto: false,
        consolidado: false,
        informacion: false,
        infAjusteConsol: false,
        infAjusteComb: false,

        // Datos de empresas
        companias: [],
        companiasFiltradas: [],
        companiaUsuario: [],
        dialogCompanias: '',
        EmpresasConsolida: [],
        selectAllCompanies: false,
        empresasSeleccion: false,

        // Fechas y reportes
        fechas: [],
        dialogReportes: '',
        reportes: [],
        dialogFechas: '',

        // Columnas
        columnas: 0,
        titulo_columna: [],

        // Otros
        generado: false,
        codigoCompanias: "",
        nivel: 1,
        descripcion: "",
        listGrupos: [],
        grupoId: 'todos',
        currency: [],
        monedaConsolidadoSeleccion: 'funcional1',
        vistaConsolidado: 'Normal',
        tituloConsolidado: "",
    }),
    computed: {
        vistaConsolidadoBool: {
            get() {
                return this.vistaConsolidado === 'Combinado';
            },
            set(value) {
                this.vistaConsolidado = value ? 'Combinado' : 'Normal';
                if (this.generado && this.consolidado) {
                    this.generar();
                }
            }
        },
        selectedViewOptionText() {
            if (!this.selectedViewOption) return this.$store.state._language == "es-ES" ? "Seleccione Vista" : "Select View"
            const option = this.viewOptions.find(opt => opt.value === this.selectedViewOption)
            return option ? option.text : this.$store.state._language == "es-ES" ? "Seleccione Vista" : "Select View"
        },
        isVigenciaBloqueada() {
            return this.dialogFechas ? !this.$store.getters.isPeriodoEnabled(this.dialogFechas) : false
        },
        balanceFiltrado() {
            if (!this.balance || this.balance.length === 0) return []
            return this.balance
        },
        isSelectorMonedaVisible() {
            return this.$store.getters.isControlVisible('ReporteEFE', 'SelectorMoneda')
        },
        isMonedaFuncional1Visible() {
            return this.$store.getters.isControlVisible('ReporteEFE', 'MonedaFuncional1')
        },
        isMonedaFuncional2Visible() {
            return this.$store.getters.isControlVisible('ReporteEFE', 'MonedaFuncional2')
        },
        isConsolidadoVisible() {
            return this.$store.getters.isControlVisible('ReporteEFE', 'Consolidado')
        },
        monedaConsolidadoOptions() {
            const options = []
            const moneda1 = this.getNombreMonedaConsolidado('funcional1')
            const moneda2 = this.getNombreMonedaConsolidado('funcional2')
            if (this.isMonedaFuncional1Visible && moneda1) {
                options.push({ value: 'funcional1', text: moneda1 })
            }
            if (this.isMonedaFuncional2Visible && moneda2) {
                options.push({ value: 'funcional2', text: moneda2 })
            }
            return options
        },
        mostrarSelectorMonedaConsolidado() {
            return this.consolidado &&
                this.isSelectorMonedaVisible &&
                this.monedaConsolidadoOptions.length > 1
        },
        labels() {
            const es = this.$store.state._language == "es-ES"
            return {
                title: es ? "Flujo de Efectivo" : "CASH FLOW",
                selectReport: es ? "Seleccione Reporte" : "Select Report",
                selectValidity: es ? "Seleccione Vigencia" : "Select Validity",
                selectCompany: es ? "Seleccione Compañía" : "Select Company",
                allGroups: es ? "Todos los grupos" : "All groups",
                comparativo: es ? "Comparativo" : "Comparative",
                directo: es ? "Directo" : "Direct",
                indirecto: es ? "Indirecto" : "Indirect",
                consolidado: es ? "Consolidado" : "Consolidated",
                informacion: es ? "Valor Manual" : "Manual Value",
                infAjusteConsol: es ? "Ajuste Consol" : "Consol Adjustment",
                infAjusteComb: es ? "Ajuste Combinado" : "Combined Adjustment",
                normal: es ? "Normal" : "Normal",
                combined: es ? "Combinado" : "Combined",
                selectCompanies: es ? "Empresas para consolidar" : "Companies to consolidate",
                selectCompaniesTitle: es ? "Selección de empresas" : "Company Selection",
                selectCompaniesSubtitle: es ? "Seleccione las empresas que desea consolidar" : "Select the companies you want to consolidate",
                selectLevel: es ? "Seleccione nivel" : "Select level",
                code: es ? "Código" : "Code",
                companyName: es ? "Nombre" : "Name",
                confirmSelection: es ? "Confirmar selección" : "Confirm selection",
                noCompaniesAvailable: es ? "No hay empresas disponibles" : "No companies available",
                selectAll: es ? "Seleccionar todas" : "Select all",
                deselectAll: es ? "Deseleccionar todas" : "Deselect all",
                selected: es ? "Seleccionadas" : "Selected",
                descripcion: es ? "Descripción" : "Description",
                saldo_anterior: es ? "Saldo Anterior" : "Previous Balance",
                saldo_actual: es ? "Saldo Actual" : "Current Balance",
                diferencia: es ? "Diferencia" : "Difference",
                monto: es ? "Valor" : "Amount",
                funcional1: es ? "Funcional" : "Functional",
                ajustes: es ? "Ajustes" : "Adjustments",
                ajustesCombinado: es ? "Ajustes Combinado" : "Combined Adjustments",
                combinado: es ? "Combinado" : "Combined",
                nivel1: es ? "Nivel 1" : "Level 1",
                nivel2: es ? "Nivel 2" : "Level 2",
                nivel3: es ? "Nivel 3" : "Level 3",
                nivel4: es ? "Nivel 4" : "Level 4",
                empty: es ? "Sin Información" : "Without Information",
                generar: es ? "Generar" : "Generate",
                moneda: es ? "Moneda" : "Currency",
                exportExcel: es ? "Exportar Excel" : "Export Excel",
                selectCriteria: es ? "Seleccione un reporte, vigencia y compañía para generar la información" : "Select a report, validity and company to generate the information",
                save: es ? "Guardar" : "Save",
                close: es ? "Cerrar" : "Close",
                noSort: es ? "Sin orden" : "No sorting",
                sortAsc: es ? "A-Z / Menor a mayor" : "A-Z / Low to high",
                sortDesc: es ? "Z-A / Mayor a menor" : "Z-A / High to low",
                columns: es ? "Columnas" : "Columns",
                showAllColumns: es ? "Mostrar todas" : "Show all",
                filters: es ? "Filtros" : "Filters",
                clearFilters: es ? "Limpiar filtros" : "Clear filters",
                rowsPerPage: es ? "Filas por página:" : "Rows per page:",
                searchPlaceholder: es ? "Buscar en la tabla..." : "Search in table...",
                noData: es ? "No hay datos disponibles" : "No data available",
                noMatches: es ? "No se encontraron resultados" : "No results found",
                edit: es ? "Editar" : "Edit",
            }
        },
        tableLabels() {
            return {
                noRow: this.labels.noData,
                noMatches: this.labels.noMatches,
                searchPlaceholder: this.labels.searchPlaceholder,
                rowsPerPage: this.labels.rowsPerPage,
                noSort: this.labels.noSort,
                sortAsc: this.labels.sortAsc,
                sortDesc: this.labels.sortDesc,
                columns: this.labels.columns,
                showAllColumns: this.labels.showAllColumns,
                filters: this.labels.filters,
                clearFilters: this.labels.clearFilters
            }
        },
        comparativoFields() {
            return [
                { key: 'descripcion', label: this.labels.descripcion, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', minWidth: '300px' },
                { key: 'anterior', label: this.labels.saldo_anterior, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) },
                { key: 'actual', label: this.labels.saldo_actual, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) },
                { key: 'diferencia', label: this.labels.diferencia, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) }
            ]
        },
        comparativoFilterDefs() {
            return [
                { key: 'descripcion', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar descripción...' : 'Filter description...' }
            ]
        },
        directoIndirectoFields() {
            return [
                { key: 'descripcion', label: this.labels.descripcion, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', minWidth: '300px' },
                { key: 'valor', label: this.labels.monto, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) }
            ]
        },
        directoIndirectoFilterDefs() {
            return [
                { key: 'descripcion', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar descripción...' : 'Filter description...' }
            ]
        },
        consolidadoFields() {
            const fields = [
                { key: 'descripcion', label: this.labels.descripcion, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', minWidth: '250px' }
            ]

            for (let i = 1; i <= this.columnas; i++) {
                const label = this.titulo_columna[i - 1] || `Empresa ${i}`
                fields.push({
                    key: this.getCampoValorConsolidado(i),
                    label: label,
                    sortable: true,
                    thClass: 'text-right',
                    tdClass: 'text-right align-middle',
                    minWidth: '120px',
                    formatter: (value) => this.formato(value)
                })
            }

            fields.push(
                { key: 'ajustes', label: this.labels.ajustes, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '120px', formatter: (value) => this.formato(value) },
                { key: 'total', label: this.labels.consolidado, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '120px', formatter: (value) => this.formato(value) }
            )

            if (this.vistaConsolidado === 'Combinado') {
                fields.push(
                    { key: 'combinado', label: this.labels.ajustesCombinado, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '120px', formatter: (value) => this.formato(value) },
                    { key: 'total_combinado', label: this.labels.combinado, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '120px', formatter: (value) => this.formato(value) }
                )
            }

            return fields
        },
        consolidadoFilterDefs() {
            return [
                { key: 'descripcion', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar descripción...' : 'Filter description...' }
            ]
        },
        informacionFields() {
            return [
                { key: 'nivel_1_desc', label: this.labels.nivel1, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', minWidth: '150px' },
                { key: 'nivel_2_desc', label: this.labels.nivel2, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', minWidth: '150px' },
                { key: 'nivel_3_desc', label: this.labels.nivel3, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', minWidth: '150px' },
                { key: 'nivel_4_desc', label: this.labels.nivel4, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', minWidth: '150px' },
                { key: 'valor', label: this.labels.monto, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) },
                { key: 'funcional1', label: this.labels.funcional1, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) },
                { key: 'accionEdit', label: this.labels.edit, thClass: 'text-center', tdClass: 'text-center', sortable: false, minWidth: '60px' }
            ]
        },
        informacionFilterDefs() {
            return [
                { key: 'nivel_1_desc', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar nivel 1...' : 'Filter level 1...' },
                { key: 'nivel_2_desc', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar nivel 2...' : 'Filter level 2...' },
                { key: 'nivel_3_desc', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar nivel 3...' : 'Filter level 3...' },
                { key: 'nivel_4_desc', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar nivel 4...' : 'Filter level 4...' }
            ]
        }
    },
    methods: {
        // ==================== MÉTODOS DE SELECCIÓN DE VISTA ====================
        selectViewOption(value) {
            console.log('=== selectViewOption ===');
            console.log('Valor seleccionado:', value);
            
            this.selectedViewOption = value
            this.onFiltroChange()

            if (value !== 'consolidado') {
                this.empresasSeleccion = false
                this.EmpresasConsolida = []
            }

            // Resetear todas las vistas
            this.comparativo = false
            this.directo = false
            this.indirecto = false
            this.consolidado = false
            this.informacion = false
            this.infAjusteConsol = false
            this.infAjusteComb = false

            // Activar la vista seleccionada
            switch(value) {
                case 'comparativo':
                    this.comparativo = true
                    break
                case 'directo':
                    this.directo = true
                    this.indirecto = false
                    break
                case 'indirecto':
                    this.indirecto = true
                    this.directo = false
                    break
                case 'consolidado':
                    this.consolidado = true
                    // ==== IMPORTANTE: Establecer indirecto por defecto para consolidado ====
                    this.indirecto = true
                    this.directo = false
                    console.log('Consolidado activado, indirecto establecido a true');
                    break
                case 'informacion':
                    this.informacion = true
                    break
                case 'infAjusteConsol':
                    this.infAjusteConsol = true
                    break
                case 'infAjusteComb':
                    this.infAjusteComb = true
                    break
            }

            console.log('Estado final - consolidado:', this.consolidado, 'indirecto:', this.indirecto);
            this.f_titulo()
        },

        // ==================== MÉTODOS PARA EL MODAL DE EMPRESAS ====================
        isCompanySelectedModal(compania) {
            return this.EmpresasConsolida.includes(compania.id)
        },

        toggleCompanySelectionModal(compania) {
            const index = this.EmpresasConsolida.indexOf(compania.id)
            if (index > -1) {
                this.EmpresasConsolida.splice(index, 1)
            } else {
                this.EmpresasConsolida.push(compania.id)
            }
            this.updateSelectAllCompaniesModal()
        },

        toggleSelectAllCompaniesModal() {
            this.selectAllCompaniesModal = !this.selectAllCompaniesModal
            if (this.selectAllCompaniesModal) {
                const selectedIds = this.companiasFiltradas.map(c => c.id)
                selectedIds.forEach(id => {
                    if (!this.EmpresasConsolida.includes(id)) {
                        this.EmpresasConsolida.push(id)
                    }
                })
            } else {
                const filteredIds = this.companiasFiltradas.map(c => c.id)
                this.EmpresasConsolida = this.EmpresasConsolida.filter(id => !filteredIds.includes(id))
            }
        },

        updateSelectAllCompaniesModal() {
            if (this.companiasFiltradas.length === 0) {
                this.selectAllCompaniesModal = false
                return
            }
            this.selectAllCompaniesModal = this.companiasFiltradas.every(c => this.EmpresasConsolida.includes(c.id))
        },

        onNivelChange() {
            console.log('=== onNivelChange ===');
            console.log('Nivel seleccionado:', this.nivelSeleccionado);
        },

        openEmpresasModal() {
            console.log('=== openEmpresasModal ===');
            this.EmpresasConsolida = []
            this.selectAllCompaniesModal = false
            this.empresasSeleccion = false
            this.nivelSeleccionado = 1
            this.showEmpresasModal = true
            this.updateSelectAllCompaniesModal()
            console.log('Modal abierto, nivel por defecto:', this.nivelSeleccionado);
        },

        closeEmpresasModal() {
            if (this.isSavingCompanies) return
            this.showEmpresasModal = false
            if (this.fromButtonGenerate) {
                this.fromButtonGenerate = false
            }
        },

        confirmEmpresasSelectionModal() {
            console.log('=== confirmEmpresasSelectionModal ===');
            
            if (this.isSavingCompanies) return
            
            if (this.EmpresasConsolida.length === 0) {
                this.$toast.warning(
                    this.$store.state._language == "es-ES"
                        ? "Por favor seleccione al menos una empresa"
                        : "Please select at least one company"
                )
                return
            }
            
            // Guardar el nivel seleccionado en la variable que usa generar()
            this.nivel = this.nivelSeleccionado
            console.log('Nivel asignado a this.nivel:', this.nivel);
            console.log('Empresas seleccionadas:', this.EmpresasConsolida);

            this.isSavingCompanies = true
            this.showEmpresasModal = false
            this.empresasSeleccion = true
            this.isSavingCompanies = false

            // Limpiar datos previos
            this.balance = []
            this.searched = []
            this.isEmpty = true
            this.generado = false
            this.columnas = 0
            this.titulo_columna = []

            console.log('Estado antes de generar:');
            console.log('  - empresasSeleccion:', this.empresasSeleccion);
            console.log('  - nivel:', this.nivel);
            console.log('  - EmpresasConsolida:', this.EmpresasConsolida);
            console.log('  - consolidado:', this.consolidado);
            console.log('  - selectedViewOption:', this.selectedViewOption);

            // Ejecutar generar después de un pequeño delay
            setTimeout(() => {
                console.log('Ejecutando generar() desde setTimeout');
                this.generar()
            }, 300)
        },

        // ==================== MÉTODO PRINCIPAL GENERAR ====================
        generar() {
            console.log('=== generar() ===');
            console.log('Estado actual:');
            console.log('  - selectedViewOption:', this.selectedViewOption);
            console.log('  - consolidado:', this.consolidado);
            console.log('  - empresasSeleccion:', this.empresasSeleccion);
            console.log('  - EmpresasConsolida:', this.EmpresasConsolida);
            console.log('  - nivel:', this.nivel);
            console.log('  - dialogCompanias:', this.dialogCompanias);
            console.log('  - dialogFechas:', this.dialogFechas);
            console.log('  - dialogReportes:', this.dialogReportes);
            console.log('  - indirecto:', this.indirecto);
            console.log('  - directo:', this.directo);

            // Si es Consolidado y no hay empresas seleccionadas, abrir modal
            if (this.selectedViewOption === 'consolidado' && !this.empresasSeleccion) {
                console.log('Consolidado sin empresas seleccionadas, abriendo modal');
                this.fromButtonGenerate = true
                this.openEmpresasModal()
                return
            }

            // Validaciones generales
            if (!this.dialogFechas) {
                this.$toast.warning(this.$store.state._language == "es-ES" ? "Por favor seleccione una vigencia" : "Please select a validity")
                return
            }
            if (!this.dialogReportes) {
                this.$toast.warning(this.$store.state._language == "es-ES" ? "Por favor seleccione un reporte" : "Please select a report")
                return
            }
            
            // Para consolidado, la compañía puede ser la seleccionada o las del modal
            if (!this.consolidado && !this.dialogCompanias) {
                this.$toast.warning(this.$store.state._language == "es-ES" ? "Por favor seleccione una compañía" : "Please select a company")
                return
            }

            // Para consolidado, si no hay empresas seleccionadas en el modal y no hay compañía seleccionada
            if (this.consolidado && !this.empresasSeleccion && !this.dialogCompanias) {
                this.$toast.warning(this.$store.state._language == "es-ES" ? "Por favor seleccione empresas para consolidar" : "Please select companies to consolidate")
                return
            }

            this.isLoading = true
            this.idCompania = this.dialogCompanias
            this.vigencia = this.dialogFechas
            this.codReporte = this.dialogReportes
            this.isEmpty = true
            this.generado = false

            const empresasSeleccionadas = [...this.EmpresasConsolida]
            const hayEmpresasSeleccionadas = this.empresasSeleccion && empresasSeleccionadas.length > 0

            console.log('Datos para la consulta:');
            console.log('  - idCompania:', this.idCompania);
            console.log('  - vigencia:', this.vigencia);
            console.log('  - codReporte:', this.codReporte);
            console.log('  - nivel:', this.nivel);
            console.log('  - consolidado:', this.consolidado);
            console.log('  - indirecto:', this.indirecto);
            console.log('  - directo:', this.directo);
            console.log('  - empresasSeleccionadas:', empresasSeleccionadas);
            console.log('  - hayEmpresasSeleccionadas:', hayEmpresasSeleccionadas);

            // ===== COMPARATIVO =====
            if (this.comparativo) {
                console.log('Ejecutando COMPARATIVO');
                Balance.getReporteEfe(this.idCompania, this.vigencia, this.codReporte)
                    .then((result) => {
                        this.balance = result.data.reporteEfe
                        this.searched = this.balance
                        if (this.balance && this.balance.length != 0) {
                            this.isEmpty = false
                            this.generado = true
                        }
                        this.isLoading = false
                    })
                    .catch((error) => {
                        console.error("Error en Comparativo:", error)
                        this.error = true
                        this.isLoading = false
                        this.$toast.error(this.$store.state._language == "es-ES" ? "Error al cargar comparativo" : "Error loading comparative")
                    })
                return
            }

            // ===== INFORMACION (VALOR MANUAL) =====
            if (this.informacion) {
                console.log('Ejecutando INFORMACION');
                Balance.getReporteInformacion(this.idCompania, this.vigencia, this.codReporte, this.directo, this.$store.state.userId)
                    .then((result) => {
                        this.balance = result.data.informacionManual
                        this.searched = this.balance
                        if (this.balance && this.balance.length != 0) {
                            this.isEmpty = false
                            this.generado = true
                        }
                        this.isLoading = false
                    })
                    .catch((error) => {
                        console.error("Error en Información:", error)
                        this.error = true
                        this.isLoading = false
                        this.$toast.error(this.$store.state._language == "es-ES" ? "Error al cargar información manual" : "Error loading manual information")
                    })
                return
            }

            // ===== AJUSTE CONSOL =====
            if (this.infAjusteConsol) {
                console.log('Ejecutando AJUSTE CONSOL');
                Balance.getReporteInformacionConsolidado(this.idCompania, this.vigencia, this.codReporte, this.directo, this.$store.state.userId)
                    .then((result) => {
                        this.balance = result.data.informacionManual
                        this.searched = this.balance
                        if (this.balance && this.balance.length != 0) {
                            this.isEmpty = false
                            this.generado = true
                        }
                        this.isLoading = false
                    })
                    .catch((error) => {
                        console.error("Error en Inf. Consolidado:", error)
                        this.error = true
                        this.isLoading = false
                        this.$toast.error(this.$store.state._language == "es-ES" ? "Error al cargar información consolidada" : "Error loading consolidated information")
                    })
                return
            }

            // ===== AJUSTE COMBINADO =====
            if (this.infAjusteComb) {
                console.log('Ejecutando AJUSTE COMBINADO');
                Balance.getReporteInformacionCombinado(this.idCompania, this.vigencia, this.codReporte, this.directo, this.$store.state.userId)
                    .then((result) => {
                        this.balance = result.data.informacionManual
                        this.searched = this.balance
                        if (this.balance && this.balance.length != 0) {
                            this.isEmpty = false
                            this.generado = true
                        }
                        this.isLoading = false
                    })
                    .catch((error) => {
                        console.error("Error en Inf. Combinado:", error)
                        this.error = true
                        this.isLoading = false
                        this.$toast.error(this.$store.state._language == "es-ES" ? "Error al cargar información combinada" : "Error loading combined information")
                    })
                return
            }

            // ===== DIRECTO =====
            if (this.directo && !this.informacion && !this.infAjusteConsol && !this.infAjusteComb) {
                let empresasParam = []
                if (this.consolidado && hayEmpresasSeleccionadas) {
                    empresasParam = empresasSeleccionadas.map(id => parseInt(id))
                } else {
                    empresasParam = [parseInt(this.idCompania)]
                }

                const monedaParam = this.getMonedaConsolidadoParametro()
                console.log('Ejecutando DIRECTO con parámetros:');
                console.log('  - empresasParam:', empresasParam);
                console.log('  - vigencia:', this.vigencia);
                console.log('  - codReporte:', this.codReporte);
                console.log('  - nivel:', this.nivel);
                console.log('  - consolidado:', this.consolidado);
                console.log('  - monedaParam:', monedaParam);

                Balance.getReporteEfeDirecto(
                    empresasParam,
                    this.vigencia,
                    this.codReporte,
                    this.nivel,
                    this.consolidado,
                    monedaParam
                )
                    .then((result) => {
                        console.log('Respuesta Directo:', result);
                        this.balance = result.data.reporteEfe
                        this.searched = this.balance
                        if (this.balance && this.balance.length != 0) {
                            this.isEmpty = false
                            this.generado = true
                            this.columnas = this.balance[0]?.columnas || 0
                            this.f_columnas()
                        }
                        if (this.consolidado) {
                            this.empresasSeleccion = false
                            this.EmpresasConsolida = []
                        }
                        this.isLoading = false
                    })
                    .catch((error) => {
                        console.error("Error en Directo:", error)
                        this.error = true
                        this.isLoading = false
                        this.$toast.error(this.$store.state._language == "es-ES" ? "Error al cargar reporte directo" : "Error loading direct report")
                    })
                return
            }

            // ===== INDIRECTO =====
			if (this.indirecto && !this.informacion && !this.infAjusteConsol && !this.infAjusteComb) {
				let empresasParam = []
				if (this.consolidado && hayEmpresasSeleccionadas) {
					empresasParam = empresasSeleccionadas.map(id => parseInt(id))
				} else {
					empresasParam = [parseInt(this.idCompania)]
				}

				// ==== IMPORTANTE: Si NO es consolidado, usar nivel 4 por defecto ====
				let nivelAUsar = this.nivel
				if (!this.consolidado) {
					nivelAUsar = 4
					console.log('No es consolidado, usando nivel 4 por defecto');
				}

				const monedaParam = this.getMonedaConsolidadoParametro()
				console.log('Ejecutando INDIRECTO con parámetros:');
				console.log('  - empresasParam:', empresasParam);
				console.log('  - vigencia:', this.vigencia);
				console.log('  - codReporte:', this.codReporte);
				console.log('  - nivel A USAR:', nivelAUsar);
				console.log('  - consolidado:', this.consolidado);
				console.log('  - monedaParam:', monedaParam);

				Balance.getReporteEfeIndirecto(
					empresasParam,
					this.vigencia,
					this.codReporte,
					nivelAUsar,  // <--- Usar la variable con el nivel correcto
					this.consolidado,
					monedaParam
				)
					.then((result) => {
						console.log('Respuesta Indirecto:', result);
						this.balance = result.data.reporteEfe
						this.searched = this.balance
						if (this.balance && this.balance.length != 0) {
							this.isEmpty = false
							this.generado = true
							this.columnas = this.balance[0]?.columnas || 0
							this.f_columnas()
						}
						if (this.consolidado) {
							this.empresasSeleccion = false
							this.EmpresasConsolida = []
						}
						this.isLoading = false
					})
					.catch((error) => {
						console.error("Error en Indirecto:", error)
						this.error = true
						this.isLoading = false
						this.$toast.error(this.$store.state._language == "es-ES" ? "Error al cargar reporte indirecto" : "Error loading indirect report")
					})
				return
			}

            console.log('No se ejecutó ninguna consulta');
            this.isLoading = false
        },

        // ==================== MÉTODOS DE COLUMNAS ====================
        f_columnas() {
            if (this.balance && this.balance.length > 0 && this.balance[0]) {
                this.titulo_columna = []
                const primerItem = this.balance[0]
                let i = 1
                while (primerItem['e' + i] !== undefined) {
                    this.titulo_columna.push(primerItem['e' + i])
                    i++
                }
                if (this.titulo_columna.length > 0) {
                    this.columnas = this.titulo_columna.length
                }
            }
        },

        getCampoValorConsolidado(index) {
            const esMoneda2 = this.monedaConsolidadoSeleccion === 'funcional2'
            const sufijo = esMoneda2 ? '_m2' : ''
            return `prom${index}${sufijo}`
        },

        getValorConsolidado(item = {}, campoBase = '', index = null) {
            if (!item) return null
            const esMoneda2 = this.monedaConsolidadoSeleccion === 'funcional2'
            const sufijo = esMoneda2 ? '_m2' : ''
            const candidatos = []
            if (campoBase === 'columna') {
                candidatos.push(`prom${index}${sufijo}`, `c${index}${sufijo}`, `c${index}`)
            } else if (campoBase === 'total') {
                candidatos.push(`total_prom${sufijo}`, `total${sufijo}`, 'total')
            } else if (campoBase === 'combinado') {
                candidatos.push(`combinado_prom${sufijo}`, `combinado${sufijo}`, 'combinado')
            } else if (campoBase === 'total_combinado') {
                candidatos.push(`total_combinado_prom${sufijo}`, `total_combinado${sufijo}`, 'total_combinado')
            } else if (campoBase === 'ajustes') {
                candidatos.push(`ajustes_prom${sufijo}`, `ajustes${sufijo}`, 'ajustes')
            }
            for (const campo of candidatos) {
                if (item[campo] !== undefined && item[campo] !== null) {
                    return item[campo]
                }
            }
            return null
        },

        // ==================== MÉTODOS DE FILTROS ====================
        onFiltroChange() {
            console.log('=== onFiltroChange ===');
            this.isEmpty = true
            this.generado = false
            this.balance = []
            this.searched = []
            this.columnas = 0
            this.titulo_columna = []
        },

		filtraCompaniasPorGrupo(valor = null) {
			console.log('=== filtraCompaniasPorGrupo ===');
			
			// Si se pasa un valor, usarlo, sino usar this.grupoId
			const grupoIdSeleccionado = valor !== null ? valor : this.grupoId
			
			console.log('grupoId seleccionado:', grupoIdSeleccionado);
			console.log('this.grupoId:', this.grupoId);
			
			this.onFiltroChange()
			this.dialogCompanias = null
			this.empresasSeleccion = false
			this.EmpresasConsolida = []
			this.selectAllCompanies = false
			
			if (grupoIdSeleccionado === 'todos' || !grupoIdSeleccionado) {
				this.companiasFiltradas = [...this.companias]
				console.log('Mostrando todas las compañías:', this.companiasFiltradas.length);
			} else {
				const grupoIdStr = grupoIdSeleccionado.toString()
				console.log('Filtrando por grupo ID:', grupoIdStr);
				
				this.companiasFiltradas = this.companias.filter(compania => {
					if (!compania?.id_grupos) return false
					const gruposCompania = compania.id_grupos.split(',').map(id => id.trim())
					return gruposCompania.includes(grupoIdStr)
				})
				console.log('Compañías filtradas:', this.companiasFiltradas.length);
			}
			
			this.companiasFiltradas.forEach(c => {
				console.log('  -', c.nombre, 'grupos:', c.id_grupos);
			})
		},

        seleccionaCompania() {
            console.log('=== seleccionaCompania ===');
            console.log('Compañía seleccionada:', this.dialogCompanias);
            this.onFiltroChange()
            let buscaMoneda = this.companias.filter((item) => item.id == this.dialogCompanias)
            if (buscaMoneda.length > 0) {
                this.moneda = buscaMoneda[0].acronimo
            } else {
                this.moneda = ''
            }
        },

        // ==================== MÉTODOS DE MONEDA ====================
        getNombreMonedaConsolidado(tipo = 'funcional1') {
            const funcionalEsperada = tipo === 'funcional2' ? 2 : 1
            const moneda = (this.currency || []).find((item) => Number(item.isFuncional) === funcionalEsperada)
            if (!moneda) return ''
            return moneda?.nombre || moneda?.acronimo || ''
        },

        getMonedaConsolidadoParametro() {
            const param = this.monedaConsolidadoSeleccion === 'funcional2' ? 2 : 1
            console.log('getMonedaConsolidadoParametro:', param);
            return param
        },

        normalizaSelectorMonedaConsolidado() {
            const opciones = this.monedaConsolidadoOptions.map((item) => item.value)
            if (opciones.length === 0) {
                this.monedaConsolidadoSeleccion = 'funcional1'
                return
            }
            if (!opciones.includes(this.monedaConsolidadoSeleccion)) {
                this.monedaConsolidadoSeleccion = opciones[0]
            }
        },

        onCambioMonedaConsolidado() {
            console.log('=== onCambioMonedaConsolidado ===');
            this.normalizaSelectorMonedaConsolidado()
            if (this.consolidado && this.generado) this.generar()
        },

        // ==================== MÉTODOS DE TÍTULO ====================
        f_titulo() {
            let titulo = ""
            let tituloEN = ""
            let tituloConsolidado = ""
            titulo = "Flujo de Efectivo"
            tituloEN = "Cash Flow "
            if (this.$store.state._language == "es-ES") {
                tituloConsolidado = titulo
            } else {
                tituloConsolidado = tituloEN
            }
            if (this.comparativo) {
                if (this.$store.state._language == "es-ES") {
                    tituloConsolidado = titulo.concat(" Comparativo")
                } else {
                    tituloConsolidado = "COMPARATIVE"
                    tituloConsolidado = tituloConsolidado.concat(" ", tituloEN)
                }
            }
            if (this.directo) {
                if (this.$store.state._language == "es-ES") {
                    tituloConsolidado = titulo.concat("-Directo")
                } else {
                    tituloConsolidado = tituloEN.concat("-Direct")
                }
            }
            if (this.indirecto) {
                if (this.$store.state._language == "es-ES") {
                    tituloConsolidado = titulo.concat("-Indirecto")
                } else {
                    tituloConsolidado = tituloEN.concat("-Indirect")
                }
            }
            if (this.informacion) {
                if (this.$store.state._language == "es-ES") {
                    tituloConsolidado = tituloConsolidado.concat(" Información")
                } else {
                    tituloConsolidado = tituloConsolidado.concat(" Information")
                }
            }
            if (this.infAjusteConsol) {
                if (this.$store.state._language == "es-ES") {
                    tituloConsolidado = tituloConsolidado.concat(" Ajuste Consolidación")
                } else {
                    tituloConsolidado = tituloConsolidado.concat(" Consolidated Adjustment")
                }
            }
            if (this.infAjusteComb) {
                if (this.$store.state._language == "es-ES") {
                    tituloConsolidado = tituloConsolidado.concat(" Ajuste Combinación")
                } else {
                    tituloConsolidado = tituloConsolidado.concat(" Combination Adjustment")
                }
            }
            if (this.consolidado && this.vistaConsolidado === 'Normal') {
                if (this.$store.state._language == "es-ES") {
                    tituloConsolidado = tituloConsolidado.concat(" (Consolidado)")
                } else {
                    tituloConsolidado = tituloConsolidado.concat(" (Consolidated)")
                }
            }
            if (this.consolidado && this.vistaConsolidado === 'Combinado') {
                if (this.$store.state._language == "es-ES") {
                    tituloConsolidado = tituloConsolidado.concat(" (Combinado)")
                } else {
                    tituloConsolidado = tituloConsolidado.concat(" (Combinado)")
                }
            }
            tituloConsolidado = tituloConsolidado.concat(" ", this.vigencia ? this.vigencia.toUpperCase() : '')
            if (!this.consolidado && this.moneda) {
                tituloConsolidado = tituloConsolidado.concat(" ", this.labels.moneda, " ", this.moneda)
            }
            this.tituloConsolidado = tituloConsolidado
            return tituloConsolidado
        },

        f_titulo_informacion() {
            if (this.infAjusteComb) {
                return this.$store.state._language == "es-ES" ? "Ajustes al combinado" : "Combined Adjustments"
            } else if (this.infAjusteConsol) {
                return this.$store.state._language == "es-ES" ? "Ajustes al Consolidado" : "Consolidated Adjustments"
            } else {
                return this.$store.state._language == "es-ES" ? "Información Manual" : "Manual Information"
            }
        },

        // ==================== MÉTODOS DE FORMATEO ====================
        formato(numero) {
            if (numero === null || numero === undefined) return ''
            if (typeof numero === 'string') {
                numero = parseFloat(numero) || 0
            }
            return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 })?.format(numero)
        },

        formatearDescripcion(descripcion) {
            if (!descripcion) return ''
            if (descripcion.startsWith('TOTAL ')) {
                return descripcion.substring(6)
            }
            return descripcion
        },

        // ==================== MÉTODOS DE EDICIÓN ====================
        f_muestra(r_informacion) {
            if (r_informacion && r_informacion.length > 0) {
                this.formInformacion = { ...r_informacion[0] }
                this.formInformacion.esConsolidado = 0
                this.showDialogInformacion = true
            }
        },

        f_muestraConsol(r_informacion) {
            if (r_informacion && r_informacion.length > 0) {
                this.formInformacion = { ...r_informacion[0] }
                this.formInformacion.esConsolidado = 1
                this.showDialogInformacion = true
            }
        },

        f_muestraComb(r_informacion) {
            if (r_informacion && r_informacion.length > 0) {
                this.formInformacion = { ...r_informacion[0] }
                this.formInformacion.esConsolidado = 2
                this.showDialogInformacion = true
            }
        },

        f_grabaInformacion() {
            if (this.isVigenciaBloqueada) {
                this.$toast.error(this.$store.state._language == "es-ES" ? 'La vigencia seleccionada está deshabilitada para edición.' : 'The selected validity is disabled for editing.')
                return
            }
            this.formInformacion.u_modifica = this.$store.state.userId
            this.formInformacion.directo = this.directo
            this.showDialogInformacion = false

            const grabarPromesa = () => {
                if (this.formInformacion.esConsolidado === 1) {
                    return Balance.grabaInformacionConsolidado(this.idCompania, this.vigencia, this.codReporte, this.formInformacion)
                } else if (this.formInformacion.esConsolidado === 2) {
                    return Balance.grabaInformacionCombinado(this.idCompania, this.vigencia, this.codReporte, this.formInformacion)
                } else {
                    return Balance.grabaInformacion(this.idCompania, this.vigencia, this.codReporte, this.formInformacion)
                }
            }

            grabarPromesa()
                .then((result) => {
                    if (result.status == 200) {
                        this.$toast.success(this.$store.state._language == "es-ES" ? "Información Grabada" : "Information Saved")
                        this.generar()
                    } else {
                        this.$toast.error(this.$store.state._language == "es-ES" ? "Problema al grabar" : "Problem saving")
                    }
                })
                .catch(() => {
                    this.error = true
                    this.$toast.error(this.$store.state._language == "es-ES" ? "Error al grabar" : "Error saving")
                })
        },

        // ==================== MÉTODOS DE EXPORTACIÓN ====================
        excel(opcion) {
            let datos = {}
            if (opcion === 1) {
                datos.opcion = 1
                datos.idCompania = this.idCompania
                const v_compania = this.companias.find((compania) => compania.id === this.idCompania)
                datos.compania = v_compania ? v_compania.nombre : ''
                datos.vigencia = this.vigencia
                datos.titulo = this.f_titulo()
                datos.columnas = [
                    this.labels.saldo_anterior,
                    this.labels.saldo_actual,
                    this.labels.diferencia
                ]
                datos.informacion = this.balanceFiltrado
                datos.userId = this.$store.state.userId
                datos.userName = this.$store.state.userName
                this.hojaExcelReporteEfe(datos)
            }
            if (opcion === 2) {
                datos.opcion = this.directo ? 1 : 2
                datos.idCompania = this.idCompania
                const v_compania = this.companias.find((compania) => compania.id === this.idCompania)
                datos.compania = v_compania ? v_compania.nombre : ''
                datos.vigencia = this.vigencia
                datos.titulo = this.f_titulo()
                datos.columnas = [
                    this.labels.descripcion,
                    this.labels.monto
                ]
                datos.informacion = this.balanceFiltrado
                datos.userId = this.$store.state.userId
                datos.userName = this.$store.state.userName
                this.hojaExcelReporteEfeDirecto(datos)
            }
            if (opcion === 3) {
                datos.opcion = this.directo ? 1 : 2
                datos.idCompania = this.idCompania
                const v_compania = this.companias.find((compania) => compania.id === this.idCompania)
                datos.compania = v_compania ? v_compania.nombre : ''
                datos.vigencia = this.vigencia
                datos.titulo = this.f_titulo()
                datos.columnas = [
                    this.labels.nivel1,
                    this.labels.nivel2,
                    this.labels.nivel3,
                    this.labels.nivel4,
                    this.labels.monto,
                    this.labels.funcional1
                ]
                datos.informacion = this.balanceFiltrado
                datos.userId = this.$store.state.userId
                datos.userName = this.$store.state.userName
                this.hojaExcelReporteEfeInformacion(datos)
            }
            if (opcion === 4) {
                datos.opcion = this.directo ? 1 : 2
                datos.idCompania = this.idCompania
                const v_compania = this.companias.find((compania) => compania.id === this.idCompania)
                datos.compania = v_compania ? v_compania.nombre : ''
                datos.idGrupo = this.grupoId
                const v_grupo = this.listGrupos.find((grupo) => grupo.id === this.grupoId)
                datos.grupo = v_grupo ? v_grupo.nombre : ''
                datos.vigencia = this.vigencia
                datos.titulo = this.f_titulo()
                const columnasTitulos = []
                for (let i = 0; i < this.columnas; i++) {
                    columnasTitulos.push(this.titulo_columna[i] || `Empresa ${i + 1}`)
                }
                datos.columnas = [
                    this.labels.descripcion,
                    ...columnasTitulos,
                    this.labels.ajustes,
                    this.labels.consolidado
                ]
                if (this.vistaConsolidado === 'Combinado') {
                    datos.columnas.push(this.labels.ajustesCombinado)
                    datos.columnas.push(this.labels.combinado)
                }
                datos.informacion = this.balanceFiltrado
                datos.columnasCount = this.columnas
                datos.monedaConsolidadoSeleccion = this.monedaConsolidadoSeleccion
                datos.vistaConsolidado = this.vistaConsolidado
                datos.userId = this.$store.state.userId
                datos.userName = this.$store.state.userName
                this.hojaExcelReporteEfeConsolidado(datos)
            }
            if (opcion === 5) {
                datos.opcion = this.directo ? 1 : 2
                datos.idCompania = this.idCompania
                const v_compania = this.companias.find((compania) => compania.id === this.idCompania)
                datos.compania = v_compania ? v_compania.nombre : ''
                datos.vigencia = this.vigencia
                datos.titulo = this.f_titulo()
                datos.columnas = [
                    this.labels.nivel1,
                    this.labels.nivel2,
                    this.labels.nivel3,
                    this.labels.nivel4,
                    this.labels.monto,
                    this.labels.funcional1
                ]
                datos.informacion = this.balanceFiltrado
                datos.userId = this.$store.state.userId
                datos.userName = this.$store.state.userName
                this.hojaExcelReporteEfeInformacionConsolidado(datos)
            }
            if (opcion === 6) {
                datos.opcion = this.directo ? 1 : 2
                datos.idCompania = this.idCompania
                const v_compania = this.companias.find((compania) => compania.id === this.idCompania)
                datos.compania = v_compania ? v_compania.nombre : ''
                datos.vigencia = this.vigencia
                datos.titulo = this.f_titulo()
                datos.columnas = [
                    this.labels.nivel1,
                    this.labels.nivel2,
                    this.labels.nivel3,
                    this.labels.nivel4,
                    this.labels.monto,
                    this.labels.funcional1
                ]
                datos.informacion = this.balanceFiltrado
                datos.userId = this.$store.state.userId
                datos.userName = this.$store.state.userName
                this.hojaExcelReporteEfeInformacionCombinado(datos)
            }
        },

        // ==================== MÉTODOS DE EXPORTACIÓN EXCEL (SIMPLIFICADOS) ====================
        async hojaExcelReporteEfe(datos) {
            this.$toast.info(this.$store.state._language == "es-ES" ? "Generando Excel..." : "Generating Excel...")
            const { Workbook } = await import("exceljs")
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("ComparativoEFE")

            worksheet.mergeCells('A1:D1')
            worksheet.getCell('A1').value = datos.titulo
            worksheet.getCell('A1').font = { name: "Calibri", size: 16, bold: true }
            worksheet.getCell('A1').alignment = { horizontal: "center", vertical: "middle" }

            worksheet.mergeCells('A2:D2')
            worksheet.getCell('A2').value = `Vigencia: ${datos.vigencia} | Compañía: ${datos.compania}`
            worksheet.getCell('A2').font = { name: "Calibri", size: 11, bold: true }
            worksheet.getCell('A2').alignment = { horizontal: "center", vertical: "middle" }

            const headers = ['DESCRIPCIÓN', 'SALDO ANTERIOR', 'SALDO ACTUAL', 'DIFERENCIA']
            const headerRow = worksheet.addRow(headers)
            headerRow.eachCell((cell) => {
                cell.font = { name: "Calibri", size: 11, bold: true }
                cell.alignment = { horizontal: "center", vertical: "middle" }
                cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }
                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" }
                }
            })

            datos.informacion.forEach((fila) => {
                const rowData = [
                    fila.descripcion || '',
                    fila.anterior !== null ? parseFloat(fila.anterior) || 0 : 0,
                    fila.actual !== null ? parseFloat(fila.actual) || 0 : 0,
                    fila.diferencia !== null ? parseFloat(fila.diferencia) || 0 : 0
                ]
                worksheet.addRow(rowData)
            })

            worksheet.columns = [{ width: 50 }, { width: 20 }, { width: 20 }, { width: 20 }]

            const file = await workbook.xlsx.writeBuffer()
            const downloadLink = document.createElement("a")
            downloadLink.download = `ComparativoEFE_${datos.vigencia}.xlsx`
            downloadLink.href = window.URL.createObjectURL(
                new Blob([file], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
            )
            downloadLink.style.display = "none"
            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
            window.URL.revokeObjectURL(downloadLink.href)
        },

        async hojaExcelReporteEfeDirecto(datos) {
            this.$toast.info(this.$store.state._language == "es-ES" ? "Generando Excel..." : "Generating Excel...")
            const { Workbook } = await import("exceljs")
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet(datos.opcion === 1 ? "EFE Directo" : "EFE Indirecto")

            worksheet.mergeCells('A1:B1')
            worksheet.getCell('A1').value = datos.titulo
            worksheet.getCell('A1').font = { name: "Calibri", size: 16, bold: true }
            worksheet.getCell('A1').alignment = { horizontal: "center", vertical: "middle" }

            worksheet.mergeCells('A2:B2')
            worksheet.getCell('A2').value = `Vigencia: ${datos.vigencia} | Compañía: ${datos.compania}`
            worksheet.getCell('A2').font = { name: "Calibri", size: 11, bold: true }
            worksheet.getCell('A2').alignment = { horizontal: "center", vertical: "middle" }

            const headers = ['DESCRIPCIÓN', 'VALOR']
            const headerRow = worksheet.addRow(headers)
            headerRow.eachCell((cell) => {
                cell.font = { name: "Calibri", size: 11, bold: true }
                cell.alignment = { horizontal: "center", vertical: "middle" }
                cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }
                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" }
                }
            })

            const filasVisibles = datos.informacion.filter((fila, index) => {
                return !this.ocultarRegistro(fila, index, datos.informacion)
            })

            filasVisibles.forEach((fila) => {
                const rowData = [
                    this.formatearDescripcion(fila.descripcion || ''),
                    fila.valor !== null ? parseFloat(fila.valor) || 0 : 0
                ]
                worksheet.addRow(rowData)
            })

            worksheet.columns = [{ width: 60 }, { width: 20 }]

            const file = await workbook.xlsx.writeBuffer()
            const downloadLink = document.createElement("a")
            downloadLink.download = (datos.opcion === 1 ? "EFE_Directo_" : "EFE_Indirecto_") + datos.vigencia + ".xlsx"
            downloadLink.href = window.URL.createObjectURL(
                new Blob([file], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
            )
            downloadLink.style.display = "none"
            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
            window.URL.revokeObjectURL(downloadLink.href)
        },

        async hojaExcelReporteEfeInformacion(datos) {
            this.$toast.info(this.$store.state._language == "es-ES" ? "Generando Excel..." : "Generating Excel...")
            const { Workbook } = await import("exceljs")
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet(datos.opcion === 1 ? "Directo Informacion" : "Indirecto Informacion")

            worksheet.mergeCells('A1:F1')
            worksheet.getCell('A1').value = datos.titulo
            worksheet.getCell('A1').font = { name: "Calibri", size: 16, bold: true }
            worksheet.getCell('A1').alignment = { horizontal: "center", vertical: "middle" }

            worksheet.mergeCells('A2:F2')
            worksheet.getCell('A2').value = `Vigencia: ${datos.vigencia} | Compañía: ${datos.compania}`
            worksheet.getCell('A2').font = { name: "Calibri", size: 11, bold: true }
            worksheet.getCell('A2').alignment = { horizontal: "center", vertical: "middle" }

            const headers = ['NIVEL 1', 'NIVEL 2', 'NIVEL 3', 'NIVEL 4', 'VALOR', 'FUNCIONAL']
            const headerRow = worksheet.addRow(headers)
            headerRow.eachCell((cell) => {
                cell.font = { name: "Calibri", size: 11, bold: true }
                cell.alignment = { horizontal: "center", vertical: "middle" }
                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" }
                }
            })

            datos.informacion.forEach((fila) => {
                const rowData = [
                    fila.nivel_1_desc || '',
                    fila.nivel_2_desc || '',
                    fila.nivel_3_desc || '',
                    fila.nivel_4_desc || '',
                    fila.valor !== null ? parseFloat(fila.valor) || 0 : 0,
                    fila.funcional1 !== null ? parseFloat(fila.funcional1) || 0 : 0
                ]
                worksheet.addRow(rowData)
            })

            worksheet.columns = [{ width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 20 }, { width: 20 }]

            const file = await workbook.xlsx.writeBuffer()
            const downloadLink = document.createElement("a")
            downloadLink.download = (datos.opcion === 1 ? "Directo_Informacion_" : "Indirecto_Informacion_") + datos.vigencia + ".xlsx"
            downloadLink.href = window.URL.createObjectURL(
                new Blob([file], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
            )
            downloadLink.style.display = "none"
            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
            window.URL.revokeObjectURL(downloadLink.href)
        },

        async hojaExcelReporteEfeConsolidado(datos) {
            this.$toast.info(this.$store.state._language == "es-ES" ? "Generando Excel..." : "Generating Excel...")
            const { Workbook } = await import("exceljs")
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet(datos.opcion === 1 ? "Consolidado Directo" : "Consolidado Indirecto")

            const monedaSeleccionada = datos.monedaConsolidadoSeleccion || this.monedaConsolidadoSeleccion
            const totalColumns = 3 + datos.columnasCount + (datos.vistaConsolidado === 'Combinado' ? 2 : 0)
            const endCol = String.fromCharCode(65 + totalColumns - 1)

            worksheet.mergeCells(`A1:${endCol}1`)
            worksheet.getCell('A1').value = datos.titulo
            worksheet.getCell('A1').font = { name: "Calibri", size: 16, bold: true }
            worksheet.getCell('A1').alignment = { horizontal: "center", vertical: "middle" }

            worksheet.mergeCells(`A2:${endCol}2`)
            worksheet.getCell('A2').value = `Vigencia: ${datos.vigencia} | ${datos.vistaConsolidado === 'Combinado' ? 'Grupo' : 'Compañía'}: ${datos.vistaConsolidado === 'Combinado' ? datos.grupo : datos.compania}`
            worksheet.getCell('A2').font = { name: "Calibri", size: 11, bold: true }
            worksheet.getCell('A2').alignment = { horizontal: "center", vertical: "middle" }

            const headerRowArray = ['DESCRIPCIÓN']
            for (let i = 0; i < datos.columnasCount; i++) {
                headerRowArray.push(this.titulo_columna[i] || `Empresa ${i + 1}`)
            }
            headerRowArray.push('AJUSTES')
            headerRowArray.push('CONSOLIDADO')
            if (datos.vistaConsolidado === 'Combinado') {
                headerRowArray.push('AJUSTES COMBINADO')
                headerRowArray.push('COMBINADO')
            }

            const headerRow = worksheet.addRow(headerRowArray)
            headerRow.eachCell((cell) => {
                cell.font = { name: "Calibri", size: 11, bold: true }
                cell.alignment = { horizontal: "center", vertical: "middle" }
                cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }
                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" }
                }
            })

            const filasFiltradas = datos.informacion.filter(item => !this.ocultarRegistro(item))
            filasFiltradas.forEach((fila) => {
                const rowData = [fila.descripcion || '']
                for (let i = 1; i <= datos.columnasCount; i++) {
                    const esMoneda2 = monedaSeleccionada === 'funcional2'
                    const sufijo = esMoneda2 ? '_m2' : ''
                    const valorRaw = fila[`prom${i}${sufijo}`] ?? fila[`c${i}${sufijo}`] ?? fila[`c${i}`]
                    rowData.push(valorRaw !== null ? parseFloat(valorRaw) || 0 : 0)
                }
                const esMoneda2 = monedaSeleccionada === 'funcional2'
                const sufijo = esMoneda2 ? '_m2' : ''
                const ajustesRaw = fila[`ajustes_prom${sufijo}`] ?? fila[`ajustes${sufijo}`] ?? fila.ajustes
                const totalRaw = fila[`total_prom${sufijo}`] ?? fila[`total${sufijo}`] ?? fila.total
                rowData.push(ajustesRaw !== null ? parseFloat(ajustesRaw) || 0 : 0)
                rowData.push(totalRaw !== null ? parseFloat(totalRaw) || 0 : 0)
                if (datos.vistaConsolidado === 'Combinado') {
                    const combinadoRaw = fila[`combinado_prom${sufijo}`] ?? fila[`combinado${sufijo}`] ?? fila.combinado
                    const totalCombinadoRaw = fila[`total_combinado_prom${sufijo}`] ?? fila[`total_combinado${sufijo}`] ?? fila.total_combinado
                    rowData.push(combinadoRaw !== null ? parseFloat(combinadoRaw) || 0 : 0)
                    rowData.push(totalCombinadoRaw !== null ? parseFloat(totalCombinadoRaw) || 0 : 0)
                }
                worksheet.addRow(rowData)
            })

            const columnWidths = [{ width: 50 }]
            for (let i = 0; i < datos.columnasCount; i++) {
                columnWidths.push({ width: 18 })
            }
            columnWidths.push({ width: 18 })
            columnWidths.push({ width: 18 })
            if (datos.vistaConsolidado === 'Combinado') {
                columnWidths.push({ width: 18 })
                columnWidths.push({ width: 18 })
            }
            worksheet.columns = columnWidths

            const file = await workbook.xlsx.writeBuffer()
            const downloadLink = document.createElement("a")
            downloadLink.download = (datos.opcion === 1 ? "Consolidado_Directo_" : "Consolidado_Indirecto_") + datos.vigencia + ".xlsx"
            downloadLink.href = window.URL.createObjectURL(
                new Blob([file], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
            )
            downloadLink.style.display = "none"
            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
            window.URL.revokeObjectURL(downloadLink.href)
        },

        async hojaExcelReporteEfeInformacionConsolidado(datos) {
            this.$toast.info(this.$store.state._language == "es-ES" ? "Generando Excel..." : "Generating Excel...")
            const { Workbook } = await import("exceljs")
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet(datos.opcion === 1 ? "Directo Inf Consolidado" : "Indirecto Inf Consolidado")

            worksheet.mergeCells('A1:F1')
            worksheet.getCell('A1').value = datos.titulo
            worksheet.getCell('A1').font = { name: "Calibri", size: 16, bold: true }
            worksheet.getCell('A1').alignment = { horizontal: "center", vertical: "middle" }

            worksheet.mergeCells('A2:F2')
            worksheet.getCell('A2').value = `Vigencia: ${datos.vigencia} | Compañía: ${datos.compania}`
            worksheet.getCell('A2').font = { name: "Calibri", size: 11, bold: true }
            worksheet.getCell('A2').alignment = { horizontal: "center", vertical: "middle" }

            const headers = ['NIVEL 1', 'NIVEL 2', 'NIVEL 3', 'NIVEL 4', 'VALOR', 'FUNCIONAL']
            const headerRow = worksheet.addRow(headers)
            headerRow.eachCell((cell) => {
                cell.font = { name: "Calibri", size: 11, bold: true }
                cell.alignment = { horizontal: "center", vertical: "middle" }
                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" }
                }
            })

            datos.informacion.forEach((fila) => {
                const rowData = [
                    fila.nivel_1_desc || '',
                    fila.nivel_2_desc || '',
                    fila.nivel_3_desc || '',
                    fila.nivel_4_desc || '',
                    fila.valor !== null ? parseFloat(fila.valor) || 0 : 0,
                    fila.funcional1 !== null ? parseFloat(fila.funcional1) || 0 : 0
                ]
                worksheet.addRow(rowData)
            })

            worksheet.columns = [{ width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 20 }, { width: 20 }]

            const file = await workbook.xlsx.writeBuffer()
            const downloadLink = document.createElement("a")
            downloadLink.download = (datos.opcion === 1 ? "Directo_Inf_Consolidado_" : "Indirecto_Inf_Consolidado_") + datos.vigencia + ".xlsx"
            downloadLink.href = window.URL.createObjectURL(
                new Blob([file], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
            )
            downloadLink.style.display = "none"
            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
            window.URL.revokeObjectURL(downloadLink.href)
        },

        async hojaExcelReporteEfeInformacionCombinado(datos) {
            this.$toast.info(this.$store.state._language == "es-ES" ? "Generando Excel..." : "Generating Excel...")
            const { Workbook } = await import("exceljs")
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet(datos.opcion === 1 ? "Directo Inf Combinado" : "Indirecto Inf Combinado")

            worksheet.mergeCells('A1:F1')
            worksheet.getCell('A1').value = datos.titulo
            worksheet.getCell('A1').font = { name: "Calibri", size: 16, bold: true }
            worksheet.getCell('A1').alignment = { horizontal: "center", vertical: "middle" }

            worksheet.mergeCells('A2:F2')
            worksheet.getCell('A2').value = `Vigencia: ${datos.vigencia} | Compañía: ${datos.compania}`
            worksheet.getCell('A2').font = { name: "Calibri", size: 11, bold: true }
            worksheet.getCell('A2').alignment = { horizontal: "center", vertical: "middle" }

            const headers = ['NIVEL 1', 'NIVEL 2', 'NIVEL 3', 'NIVEL 4', 'VALOR', 'FUNCIONAL']
            const headerRow = worksheet.addRow(headers)
            headerRow.eachCell((cell) => {
                cell.font = { name: "Calibri", size: 11, bold: true }
                cell.alignment = { horizontal: "center", vertical: "middle" }
                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" }
                }
            })

            datos.informacion.forEach((fila) => {
                const rowData = [
                    fila.nivel_1_desc || '',
                    fila.nivel_2_desc || '',
                    fila.nivel_3_desc || '',
                    fila.nivel_4_desc || '',
                    fila.valor !== null ? parseFloat(fila.valor) || 0 : 0,
                    fila.funcional1 !== null ? parseFloat(fila.funcional1) || 0 : 0
                ]
                worksheet.addRow(rowData)
            })

            worksheet.columns = [{ width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 20 }, { width: 20 }]

            const file = await workbook.xlsx.writeBuffer()
            const downloadLink = document.createElement("a")
            downloadLink.download = (datos.opcion === 1 ? "Directo_Inf_Combinado_" : "Indirecto_Inf_Combinado_") + datos.vigencia + ".xlsx"
            downloadLink.href = window.URL.createObjectURL(
                new Blob([file], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
            )
            downloadLink.style.display = "none"
            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
            window.URL.revokeObjectURL(downloadLink.href)
        },

        // ==================== MÉTODOS AUXILIARES ====================
        ocultarRegistro(item, index, array) {
            if (!item) return false
            if (item.tipo === "I" && item.valor !== null && parseFloat(item.valor) === 0) {
                return true
            }
            if (item.tipo === "T" && item.valor !== null && parseFloat(item.valor) === 0) {
                return true
            }
            if (item.tipo === "E" && index > 0) {
                for (let i = index - 1; i >= 0; i--) {
                    const anterior = array[i]
                    if (!anterior) continue
                    if (anterior.tipo === "E" &&
                        anterior.descripcion === item.descripcion &&
                        anterior.n1 === item.n1) {
                        if (anterior.n2 === 0 && item.n2 > 0) {
                            return true
                        }
                        if (anterior.n2 < item.n2) {
                            break
                        }
                    }
                    if (anterior.n1 !== item.n1) {
                        break
                    }
                }
            }
            if (item.tipo === "E" && array && Array.isArray(array) && index !== undefined) {
                for (let i = index + 1; i < array.length; i++) {
                    const siguiente = array[i]
                    if (!siguiente) continue
                    if (siguiente.tipo === "I" &&
                        siguiente.n1 === item.n1 &&
                        siguiente.n2 === item.n2) {
                        const descEncabezado = (item.descripcion || '').trim().toLowerCase()
                        const descInfo = (siguiente.descripcion || '').trim().toLowerCase()
                        if (!descEncabezado.includes(descInfo) && !descInfo.includes(descEncabezado)) {
                            return false
                        } else {
                            break
                        }
                    }
                    if (siguiente.tipo === "E" && siguiente.n2 !== item.n2) {
                        break
                    }
                }
            }
            if (item.n2 === 99 && item.n3 === 99 && item.n4 === 99) {
                return false
            }
            if (item.n2 >= 1 && item.n2 <= 98 && item.n3 === 0 && item.n4 === 0) {
                return true
            }
            if (item.n2 >= 1 && item.n2 <= 98 && item.n3 === 99 && item.n4 === 99) {
                return true
            }
            return false
        },

        // ==================== CONTROL DE BOTONES ====================
        async loadButtonControlsFromDb() {
            const defaultControls = {
                Consolidado: true,
                Informacion: true,
                InfAjusteConsol: true,
                InfAjusteComb: true,
                SelectorMoneda: true,
                MonedaFuncional1: true,
                MonedaFuncional2: true
            }
            const controlMap = {
                300: "Consolidado",
                720: "Informacion",
                730: "InfAjusteConsol",
                740: "InfAjusteComb",
                600: "SelectorMoneda",
                610: "MonedaFuncional1",
                620: "MonedaFuncional2"
            }
            try {
                const roleId = Number(this.$store.state.userRole) || 0
                const response = await BotonesControl.getBotonesControl("REPORTEEFE", roleId)
                const botones = Array.isArray(response.data.botones) ? response.data.botones : []
                const controls = { ...defaultControls }
                botones.forEach((item) => {
                    const key = controlMap[Number(item.id_boton)]
                    if (!key) return
                    controls[key] = item.enabled !== false
                })
                this.$store.commit("setComponentControls", { componentName: "ReporteEFE", controls })
            } catch (error) {
                console.log("Error cargando visibilidad de botones EFE:", error)
            } finally {
                if (!this.isConsolidadoVisible) {
                    this.consolidado = false
                    this.empresasSeleccion = false
                }
                this.normalizaSelectorMonedaConsolidado()
            }
        },

        goBack() {
            this.$router.back()
        }
    },
    async mounted() {
        this.isLoading = true
        await this.loadButtonControlsFromDb()

        try {
            const resultCompaniaUsuario = await Balance.leaCompaniaUsuario()
            this.companiaUsuario = resultCompaniaUsuario.data.companiaUsuario || []
        } catch {
            this.error = true
            this.companiaUsuario = []
        }

        try {
            const resultCompanias = await Balance.getCompanias(this.comparativo)
            this.companias = resultCompanias.data.companias
            this.companiasFiltradas = [...this.companias]
            this.dialogCompanias = ''
            this.codigoCompanias = "{"
            let primero = true
            let v_companias = []
            resultCompanias.data.companias.forEach((element) => {
                const v_usuario = this.companiaUsuario.find((r_usuario) =>
                    r_usuario.id_usuario == this.$store.state.userId &&
                    r_usuario.id_compania == element.id)
                if (this.$store.state.userRole == 1 || v_usuario) {
                    v_companias.push(element)
                }
            })
            this.companias = v_companias
            this.companiasFiltradas = [...this.companias]
            resultCompanias.data.companias.forEach(element => {
                if (!primero) this.codigoCompanias = this.codigoCompanias + ","
                primero = false
                this.codigoCompanias = this.codigoCompanias + "\"id" + element.id + "\":" + "\"" + element.codigo + "\""
            })
            this.codigoCompanias = this.codigoCompanias + "}"
            this.codigoCompanias = JSON.parse(this.codigoCompanias)
        } catch {
            this.error = true
        }

        Balance.getFechas()
            .then((result) => {
                this.fechas = result.data.fechas
                this.dialogFechas = ''
            })
            .catch(() => { this.error = true })

        Balance.getReportes()
            .then((result) => {
                this.reportes = result.data.reportes
            })
            .catch(() => { this.error = true })

        Currency.getAllCurrency()
            .then((result) => {
                this.currency = result.data.currency || []
                this.normalizaSelectorMonedaConsolidado()
            })
            .catch(() => { this.error = true })

        Grupo.getAllGrupos()
            .then((result) => {
                this.listGrupos = result.data.grupos
                this.grupoId = 'todos'
            })
            .catch(() => { this.error = true })

        this.isLoading = false
        this.indirecto = true
        this.f_titulo()
        console.log('=== ReporteEFE mounted ===');
        console.log('Estado inicial:');
        console.log('  - indirecto:', this.indirecto);
        console.log('  - consolidado:', this.consolidado);
        console.log('  - selectedViewOption:', this.selectedViewOption);
    },
}
</script>

<style src="../main.css"></style>

<style scoped>
/* ========== ESTILOS DE FILTROS PRINCIPALES ========== */
.niif-header .filters-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    margin-left: 0 !important;
}

.niif-header .filter-select {
    min-width: 200px;
    max-width: 280px;
    width: auto;
    height: 38px;
    font-size: 14px;
    border-radius: 7px;
}

.niif-header .filter-select option {
    white-space: normal;
    word-break: break-word;
    padding: 4px 8px;
}

/* ========== DROPDOWN DE SELECCIÓN ÚNICA ========== */
.filter-dropdown {
    display: inline-block;
}

.filter-dropdown .filter-dropdown-btn {
    height: 38px;
    min-height: 38px;
    padding: 0 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 14px;
    background-color: transparent !important;
    color: #6c757d !important;
    border: 1px solid #6c757d !important;
    cursor: pointer;
    flex-shrink: 0;
}

.filter-dropdown .filter-dropdown-btn:hover:not(:disabled) {
    background-color: #6c757d !important;
    color: white !important;
}

.filter-dropdown .filter-dropdown-btn:focus {
    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5) !important;
}

.filter-dropdown .filter-dropdown-btn::after {
    margin-left: 8px;
}

.filter-dropdown .dropdown-item.active {
    background-color: #1f4f83 !important;
    color: white !important;
}

.filter-dropdown .dropdown-item:hover:not(.active) {
    background-color: #e9ecef !important;
}

/* ========== BOTÓN GENERAR ========== */
.niif-header .consult-btn {
    height: 38px;
    min-height: 38px;
    padding: 0 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 14px;
    background-color: #6c757d !important;
    color: white !important;
    border: 1px solid #6c757d !important;
    cursor: pointer;
    flex-shrink: 0;
}

.niif-header .consult-btn:hover:not(:disabled) {
    background-color: #5a6268 !important;
    border-color: #545b62 !important;
}

.niif-header .consult-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

/* ========== TOOLBAR ========== */
.niif-toolbar-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex: 0 0 auto;
}

.niif-toolbar-right .table-toolbar-export-btn {
    height: 31px;
    min-height: 31px;
    padding: 0 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 13px;
    background-color: #1f4f83 !important;
    color: white !important;
    border: 1px solid #1f4f83 !important;
}

.niif-toolbar-right .table-toolbar-export-btn:hover:not(:disabled) {
    background-color: #1a446f !important;
    border-color: #1a446f !important;
}

.niif-toolbar-right .table-toolbar-export-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

/* ========== MODALES ========== */
.modal-header-custom {
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
    padding: 12px 20px;
}

.modal-footer-custom {
    background-color: #f8f9fa;
    border-top: 1px solid #dee2e6;
    padding: 12px 20px;
}

/* ========== ESTILOS DEL MODAL DE EMPRESAS ========== */
.table-active-blue {
    background-color: #e3f0ff !important;
    border-radius: 8px !important;
}

.table-active-blue td {
    background-color: #e3f0ff !important;
}

.custom-scroll-table {
    height: 250px;
    min-height: 250px;
    max-height: 300px;
    overflow-y: auto;
    position: relative;
}

.custom-scroll-table::-webkit-scrollbar {
    width: 8px;
}

.custom-scroll-table::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.custom-scroll-table::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
}

.custom-scroll-table::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.uniform-modal-body {
    padding: 8px 4px 4px 4px;
}

.uniform-actions-wrap {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #e9ecef;
}

.reset-btn-secondary {
    background-color: #f8f9fa !important;
    border: 1px solid #ced4da !important;
    color: #495057 !important;
}

.reset-btn-secondary:hover:not(:disabled) {
    background-color: #e9ecef !important;
    border-color: #adb5bd !important;
}

.reset-btn-primary {
    background-color: #2e507a !important;
    border: 1px solid #2e507a !important;
    color: white !important;
}

.reset-btn-primary:hover:not(:disabled) {
    background-color: #1f3f62 !important;
    border-color: #1f3f62 !important;
}

.reset-btn-primary:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

/* ========== ESTILOS DE FLECHA Y TÍTULO ========== */
.page-back-btn {
    padding: 0;
    font-size: 1.5rem;
    line-height: 1;
}

.back-icon {
    font-size: 1.75rem !important;
    width: 1.75rem !important;
    height: 1.75rem !important;
}

.param-title {
    font-size: 2rem !important;
    font-weight: 500;
}

/* ========== SWITCH TOGGLE ========== */
.compact-toggle-container {
    display: flex;
    align-items: center;
    gap: 8px;
}

.compact-switch {
    position: relative;
    display: inline-block;
    width: 44px;
    height: 24px;
    flex-shrink: 0;
}

.compact-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.compact-switch .compact-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .3s;
    border-radius: 24px;
}

.compact-switch .compact-slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: .3s;
    border-radius: 50%;
}

.compact-switch input:checked + .compact-slider {
    background-color: #1f4f83;
}

.compact-switch input:checked + .compact-slider:before {
    transform: translateX(20px);
}

/* ========== SELECCIÓN DE NIVELES ========== */
.nivel-selection-section {
    background: #f8f9fa;
    padding: 12px 16px;
    border-radius: 8px;
    border: 1px solid #e9ecef;
}

.nivel-radio-group .btn {
    font-size: 13px;
    padding: 4px 16px;
    border-radius: 4px;
}

.nivel-radio-group .btn.active {
    background-color: #2e507a !important;
    color: white !important;
    border-color: #2e507a !important;
}

.nivel-radio-group .btn:hover:not(.active) {
    background-color: #e9ecef;
}

/* ========== RESPONSIVE ========== */
@media (max-width: 1200px) {
    .niif-header .filter-select {
        min-width: 160px;
        max-width: 220px;
        height: 36px;
        font-size: 13px;
    }

    .niif-header .consult-btn,
    .filter-dropdown .filter-dropdown-btn {
        height: 36px;
        min-height: 36px;
        font-size: 13px;
        padding: 0 16px;
    }
}

@media (max-width: 992px) {
    .niif-header .filters-container {
        flex-wrap: wrap;
        width: 100%;
        margin-top: 8px;
        margin-left: 0 !important;
        justify-content: flex-start;
        gap: 6px;
    }

    .niif-header .filter-select {
        min-width: 150px;
        max-width: 200px;
        height: 36px;
        font-size: 13px;
        flex: 1 1 auto;
    }

    .niif-header .consult-btn,
    .filter-dropdown .filter-dropdown-btn {
        height: 36px;
        min-height: 36px;
        font-size: 13px;
        padding: 0 16px;
    }

    .nivel-selection-section {
        flex-wrap: wrap;
    }

    .nivel-radio-group {
        flex-wrap: wrap;
    }
}

@media (max-width: 768px) {
    .niif-toolbar-right {
        flex-wrap: wrap;
        justify-content: flex-start;
    }

    .compact-toggle-container {
        width: 100%;
        justify-content: center;
    }
}

@media (max-width: 576px) {
    .param-title {
        font-size: 1.5rem !important;
    }

    .niif-header .filter-select {
        min-width: 100%;
        max-width: 100%;
        height: 36px;
        font-size: 13px;
        flex: 0 0 100%;
    }

    .niif-header .filters-container {
        gap: 4px;
    }

    .niif-header .consult-btn,
    .filter-dropdown .filter-dropdown-btn {
        width: 100%;
        flex: 0 0 100%;
        height: 36px;
        margin-left: 0 !important;
        margin-top: 4px;
        font-size: 13px;
        padding: 0 16px;
    }

    .nivel-selection-section {
        flex-direction: column;
        align-items: flex-start !important;
    }

    .nivel-radio-group {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
    }

    .nivel-radio-group .btn {
        flex: 1;
        text-align: center;
        font-size: 12px;
        padding: 4px 8px;
    }
}
</style>